import { BuyAndBuildListDocument, useLabelBuyAndBuildTargetQualityMutation } from '../../../gql/generated/graphql';
import { MUI_RATING_SCALE } from '../BuyBuildPage';

export const useTargetRating = (companyId: string) => {
  const [rateBuyAndBuild, { loading: rateBuyAndBuildLoading }] = useLabelBuyAndBuildTargetQualityMutation();

  const handleRateTarget = async (targetCompanyId: number, rating: number) => {
    const quality = rating / MUI_RATING_SCALE;

    await rateBuyAndBuild({
      variables: {
        quality,
        softwareCompanyId: parseInt(companyId),
        targetCompanyId,
      },
      optimisticResponse: {
        labelBuyAndBuildTargetQuality: {
          __typename: 'LabelBuyAndBuildTargetQuality',
          ok: true,
        },
      },
      update: cache => {
        const baseVars = { companyId: parseInt(companyId), first: 10 };

        // Update Longlist cache (no isShortlisted filter)
        try {
          cache.updateQuery({ query: BuyAndBuildListDocument, variables: baseVars }, (data: any) => {
            if (!data) return data;
            const next = { ...data };
            const edges = next?.companyAssesment?.edges;
            if (!edges || !edges[0]?.node?.buyAndBuildTargets?.edges) return data;
            const targetEdges = edges[0].node.buyAndBuildTargets.edges;
            edges[0].node.buyAndBuildTargets.edges = targetEdges.map((edge: any) => {
              if (edge?.node?.company?.dbId === targetCompanyId) {
                return {
                  ...edge,
                  node: {
                    ...edge.node,
                    manuallyLabeledScore: quality,
                  },
                };
              }
              return edge;
            });
            return next;
          });
        } catch {
          // ignore cache miss
        }

        // Update Shortlist cache (isShortlisted = true)
        try {
          cache.updateQuery(
            { query: BuyAndBuildListDocument, variables: { ...baseVars, isShortlisted: true } },
            (data: any) => {
              if (!data) return data;
              const next = { ...data };
              const edges = next?.companyAssesment?.edges;
              if (!edges || !edges[0]?.node?.buyAndBuildTargets?.edges) return data;
              const targetEdges = edges[0].node.buyAndBuildTargets.edges;
              edges[0].node.buyAndBuildTargets.edges = targetEdges.map((edge: any) => {
                if (edge?.node?.company?.dbId === targetCompanyId) {
                  return {
                    ...edge,
                    node: {
                      ...edge.node,
                      manuallyLabeledScore: quality,
                    },
                  };
                }
                return edge;
              });
              return next;
            }
          );
        } catch {
          // ignore cache miss
        }
      },
    });
  };

  return {
    handleRateTarget,
    rateBuyAndBuildLoading,
  };
};
